export interface VideoItem {
  id: string;
  title: string;
  slug: string;
  category: string;
  thumbnail: string;
  duration: string;
  quality: string;
  views: number;
  rating: number;
  description: string;
  publishDate: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '长安十二时辰',
    slug: 'changan-shier-shichen',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20Tang%20Dynasty%20ancient%20city%20with%20lanterns%20at%20night%2C%20cinematic%20lighting%2C%20rich%20warm%20tones%2C%20epic%20composition%2C%20film%20poster%20style%20with%20Chinese%20calligraphy%20title%2C%20dramatic%20mood&width=640&height=360&seq=video-thumb-001&orientation=landscape',
    duration: '45分钟/集',
    quality: '4K',
    views: 12800000,
    rating: 9.2,
    description: '改编自马伯庸同名小说，讲述了唐代上元节前夕，长安城陷入危机，死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安的故事。',
    publishDate: '2026-07-15',
    tags: ['古装', '悬疑', '历史', '热门推荐'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v002',
    title: '流浪地球3',
    slug: 'liulang-diqiu-3',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=sci%20fi%20movie%20poster%20with%20Earth%20in%20space%20giant%20engines%2C%20cinematic%20atmosphere%2C%20deep%20space%20background%20with%20stars%2C%20warm%20orange%20engine%20glow%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20film%20poster%20aesthetic&width=640&height=360&seq=video-thumb-002&orientation=landscape',
    duration: '148分钟',
    quality: '4K HDR',
    views: 35600000,
    rating: 9.5,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启长达2500年的星际流浪之旅。第三部将揭开宇宙更深层的秘密。',
    publishDate: '2026-06-20',
    tags: ['科幻', '灾难', '冒险', '热门推荐'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'v003',
    title: '向往的生活 第八季',
    slug: 'xiangwang-shenghuo-8',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20rural%20countryside%20courtyard%20with%20wooden%20house%20and%20green%20fields%2C%20warm%20sunset%20light%2C%20cozy%20atmosphere%2C%20farm%20life%20aesthetic%2C%20reality%20show%20style%20banner%20with%20natural%20colors&width=640&height=360&seq=video-thumb-003&orientation=landscape',
    duration: '90分钟/期',
    quality: '1080P',
    views: 8500000,
    rating: 8.9,
    description: '一群明星嘉宾远离城市喧嚣，来到宁静的乡村，体验自给自足的田园生活，在劳作与欢笑中感受生活最本真的美好。',
    publishDate: '2026-07-28',
    tags: ['真人秀', '生活', '治愈', '热门推荐'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'v004',
    title: '大国重器 第三季',
    slug: 'daguo-zhongqi-3',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=modern%20Chinese%20industrial%20manufacturing%20factory%20with%20advanced%20machinery%2C%20high%20tech%20engineering%2C%20clean%20professional%20environment%2C%20warm%20industrial%20lighting%2C%20documentary%20style%20cinematography&width=640&height=360&seq=video-thumb-004&orientation=landscape',
    duration: '50分钟/集',
    quality: '4K',
    views: 6200000,
    rating: 9.4,
    description: '聚焦中国高端制造业，从高铁到航天，从芯片到新能源，展现中国制造的硬核实力与创新精神。',
    publishDate: '2026-07-10',
    tags: ['科技', '工业', '纪实', '推荐'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v005',
    title: '哪吒之魔童闹海',
    slug: 'nezha-motong-naohai',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20mythological%20character%20with%20fire%20elements%20and%20dragon%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20epic%20fantasy%20scene%2C%20dynamic%20composition%2C%20animated%20film%20poster%20style&width=640&height=360&seq=video-thumb-005&orientation=landscape',
    duration: '135分钟',
    quality: '4K',
    views: 45000000,
    rating: 9.7,
    description: '天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，过程中却遭遇重重困难。',
    publishDate: '2026-05-01',
    tags: ['动画', '神话', '冒险', '热门推荐'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v006',
    title: '隐秘的角落2',
    slug: 'yinmi-jiaoluo-2',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=mysterious%20urban%20alley%20at%20dusk%20with%20dim%20street%20lights%2C%20suspenseful%20mood%2C%20Chinese%20city%20backdrop%2C%20noir%20style%20cinematography%2C%20thriller%20drama%20poster%20aesthetic&width=640&height=360&seq=video-thumb-006&orientation=landscape',
    duration: '50分钟/集',
    quality: '4K',
    views: 9800000,
    rating: 8.8,
    description: '三个孩子在一个暑假里无意间记录了一场谋杀，他们的命运从此交织在一起。第二季将揭开更多不为人知的秘密。',
    publishDate: '2026-07-22',
    tags: ['悬疑', '犯罪', '剧情', '新剧'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'v007',
    title: '中国诗词大会 第十季',
    slug: 'zhongguo-shici-dahui-10',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20classical%20poetry%20competition%20stage%20with%20ink%20wash%20painting%20style%20background%2C%20elegant%20traditional%20design%2C%20warm%20golden%20lighting%2C%20cultural%20TV%20show%20aesthetic&width=640&height=360&seq=video-thumb-007&orientation=landscape',
    duration: '90分钟/期',
    quality: '1080P',
    views: 7200000,
    rating: 9.3,
    description: '以"赏中华诗词、寻文化基因、品生活之美"为宗旨，通过知识竞赛的形式，重温经典诗词，传承中华文化。',
    publishDate: '2026-07-05',
    tags: ['文化', '诗词', '竞赛', '推荐'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'v008',
    title: '飞驰人生3',
    slug: 'feichi-rensheng-3',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=racing%20car%20on%20desert%20rally%20track%20with%20dust%20trail%2C%20golden%20sunset%20light%2C%20action%20sports%20film%20poster%20style%2C%20dynamic%20motion%2C%20dramatic%20composition&width=640&height=360&seq=video-thumb-008&orientation=landscape',
    duration: '130分钟',
    quality: '4K HDR',
    views: 18500000,
    rating: 8.7,
    description: '曾经的赛车冠军张驰重返赛道，面对新一代年轻车手的挑战，他用热爱与执着书写属于自己的传奇。',
    publishDate: '2026-08-01',
    tags: ['喜剧', '运动', '励志', '新片'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'v009',
    title: '风味人间 第五季',
    slug: 'fengwei-renjian-5',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20cuisine%20food%20preparation%20closeup%20with%20steam%20and%20warm%20lighting%2C%20traditional%20kitchen%20setting%2C%20mouthwatering%20food%20photography%2C%20documentary%20style%20food%20cinematography&width=640&height=360&seq=video-thumb-009&orientation=landscape',
    duration: '50分钟/集',
    quality: '4K',
    views: 11000000,
    rating: 9.6,
    description: '在全球视野下探寻中国美食的独特性，在美食中感受风土人情，探寻食物与人的故事。',
    publishDate: '2026-07-18',
    tags: ['美食', '人文', '纪实', '推荐'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v010',
    title: '灵笼 第二季',
    slug: 'linglong-2',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=post%20apocalyptic%20sci%20fi%20animation%20scene%20with%20floating%20city%20and%20monsters%2C%20dark%20atmospheric%20lighting%2C%20Chinese%20anime%20style%2C%20dramatic%20and%20epic%20composition%2C%20futuristic%20mecha%20design&width=640&height=360&seq=video-thumb-010&orientation=landscape',
    duration: '30分钟/集',
    quality: '4K',
    views: 7600000,
    rating: 9.1,
    description: '在未来末日世界，人类居住在一座悬浮于空中的堡垒中，地面充满了未知的危险生物，幸存者们为生存而战。',
    publishDate: '2026-07-12',
    tags: ['科幻', '末日', '机甲', '国漫'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'v011',
    title: '乘风破浪的姐姐 第五季',
    slug: 'chengfeng-polang-5',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20female%20celebrities%20on%20stage%20performing%20with%20colorful%20stage%20lights%2C%20competitive%20reality%20show%20atmosphere%2C%20glamorous%20costumes%2C%20dynamic%20performance%20scene&width=640&height=360&seq=video-thumb-011&orientation=landscape',
    duration: '120分钟/期',
    quality: '4K',
    views: 14200000,
    rating: 8.5,
    description: '30岁以上的女艺人重新出发，通过舞台竞演展现成熟女性的魅力与实力，传递积极向上的生活态度。',
    publishDate: '2026-06-15',
    tags: ['竞演', '女性', '音乐', '热门'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'v012',
    title: '镖人',
    slug: 'biaoren',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20animation%20desert%20scene%20with%20warrior%20on%20horseback%2C%20ancient%20Chinese%20setting%2C%20ink%20wash%20painting%20style%2C%20dynamic%20action%20pose%2C%20dramatic%20composition&width=640&height=360&seq=video-thumb-012&orientation=landscape',
    duration: '25分钟/集',
    quality: '4K',
    views: 5400000,
    rating: 9.0,
    description: '大业三年，隋炀帝暴政，民不聊生。身手不凡的镖客刀马行走于西域大漠，卷入一场惊天阴谋之中。',
    publishDate: '2026-08-03',
    tags: ['武侠', '历史', '动作', '国漫'],
    isHot: false,
    isNew: true,
  },
];